<template>
  <header>
    <h1><router-link :to="{ name: 'stacks'}">stacks</router-link></h1>
    <!-- <input placeholder="Search" v-model="searchQuery" debounce="500"> -->
    <div class="user-nav">
      <div v-if="user">
          <img :src="user.imageUrl" :alt="user.userTitle" v-if="user.imageUrl"/>
          <span>{{user.userTitle}}</span>
          <a href="#" v-on:click.prevent="signOut">
            sign out
          </a>          
      </div>

      

      
    </div>
    
  </header>
</template>
<script>
  import Auth from '../data/Auth'
  import EventBus from './EventBus'
  export default {
    props: ['user'],
    data () {
      return {
        //user: null,
        searchQuery: ''
      }
    },
    watch: {
      'searchQuery': function () {
        EventBus.$emit('search', this.searchQuery)
      }
    },
    methods: {
      // processUser (authed) {
      //   if (authed === null) {
      //     this.user = null
      //     return
      //   }

      //   this.user = {

      //     userTitle: authed.providerData[0].displayName || authed.providerData[0].email || '', // if there's no displayName, take the email, if there's no email, use an empty string
      //     imageUrl: authed.providerData[0].photoURL // Firebase 3 no longer supports auto Gravatar image fetch
      //   }
      // },
      signOut () {
        Auth.signOut()
        this.$router.push('auth')
      }
    },
    // created () {
    //   Auth.onAuth(this.processUser) // processUser everytime auth state changes (signs in or out)
    //   this.processUser(Auth.getAuth()) // processUser in case user is already signed in
    // }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// HeaderBar.vue?431b2db6